/* eslint-disable arrow-body-style */
import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { formatDateStr, toFirstUpperCase } from '@gp/utils/common';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IUpdateDescriptionProps extends IBaseProps {
  data?: {
    page?: string;
    update_user?: string;
    update_time?: string;
  };
}

const formatUpdateDescription = (updatePage?: string, updateUser?: string, updateTime?: string): string => {
  return `${updatePage || '-'} updated by ${updateUser || '-'} on ${updateTime || '-'}`;
};

// 两行展示
const render2Lines = (updatePage?: string, updateUser?: string, updateTime?: string) => {
  return (
    <>
      {updatePage || '-'} updated by
      <br />
      {updateUser || '-'} on {updateTime || '-'}
    </>
  );
};

// 三行展示
const render3Lines = (updatePage?: string, updateUser?: string, updateTime?: string) => {
  return (
    <>
      {updatePage || '-'} updated by
      <br />
      {updateUser || '-'}
      <br />
      on {updateTime || '-'}
    </>
  );
};

const UpdateDescription: React.FC<IUpdateDescriptionProps> = (props) => {
  const { style, className, data } = props;
  const { page: updatePage, update_user: updateUser, update_time: updateTime } = data || {};
  const updatePageTmp = updatePage ? toFirstUpperCase(updatePage) : '';
  const updateTimeTmp = formatDateStr(updateTime) || '';
  const isEmpty = !updatePageTmp && !updateUser && !updateTimeTmp;
  const updateDescription = formatUpdateDescription(updatePageTmp, updateUser, updateTimeTmp);

  const node = useRef<HTMLDivElement>(null);

  const [isOverflow, setIsOverflow] = useState(false);

  const renderContext = () => {
    if (isEmpty) return '-';
    if (isOverflow) return render3Lines(updatePageTmp, updateUser, updateTimeTmp);
    return render2Lines(updatePageTmp, updateUser, updateTimeTmp);
  };

  useEffect(() => {
    const offsetHeight = node.current?.offsetHeight || 0;
    // 行高为22，总高度大于44px（即两行）判定为溢出，on YYYY-MM-DD需要放在第三行展示，否则两行展示
    setIsOverflow(offsetHeight > 22 * 2);
  }, [updateDescription]);

  return (
    <div className={classnames('dbg-pipeline-list-update-description', className)} ref={node} style={style}>
      {renderContext()}
    </div>
  );
};

export default UpdateDescription;
